import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DeviceType } from '../models/interfaces/device-type.type';

@Injectable({
  providedIn: 'root',
})

export class DeviceWidthService {
  private deviceType = new BehaviorSubject<DeviceType>('desktop');

  getDeviceType$() {
    return this.deviceType.asObservable();
  }

  setDeviceType(windowWidth: number) {

    let type: DeviceType;

    if (windowWidth < 768) {
      type = 'mobile';
    } else if (windowWidth >= 768 && windowWidth < 1200) {
      type = 'tablet';
    } else {
      type = 'desktop';
    }

    this.deviceType.next(type)
  }
}